export default __webpack_public_path__ + "static/media/checkmark.8cd354fa.svg";